import React from 'react';
import { useTranslation } from 'react-i18next';
import { CardPaymentRedirect } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function CardPaymentRedirectPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('card-payment-redirect-component.metatags.title'),
        description: t('card-payment-redirect-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.cardPaymentRedirect,
        index: false,
    });

    return <CardPaymentRedirect />;
}
